import * as t from "./type";

const initialState = {
  primaryTextButton: "",
  secondaryTextButton: "",
  hasCoupon: "",
  couponCardTitle: "",
  couponCardAuxText: "",
  couponCardBgColor: "",
  couponCardPrimaryBtnColor: "",
  couponCardPrimaryBtnTextColor: "",
  landingOrder: [],
  landingTitle: "",
  landingName: "",
  isGeneric: "",
  especificsCoupons: [],
  partnerLogo: "",
  veloeLogo: "",
  bannerPrimaryText: "",
  bannerSecondaryText: "",
  bannerBgImage: "",
  hasPrimmaryBtn: "",
  hasSecondaryBtn: "",
  secondaryBorderBtn: "",
  bannerTitle: "",
  bannerTitleColor: "",
  bannerMessage: "",
  bannerMessageColor: "",
  bannerPrimaryBtnColor: "",
  bannerPrimaryBtnTextColor: "",
  bannerSecondaryBtnColor: "",
  bannerSecondaryBtnTextColor: "",
  parking: "",
  tolls: "",
  parkingAndToll: "",
  regulamento: "",
  simpleSectionBgColor: "",
  simpleSectionDescription: "",
  simpleSectionImage: "",
  simpleSectionTitle: "",
  simpleSectionTextColor: "",
  mapTitle: "",
  mapDescriptions: "",
  stepsBgColor: "",
  steps: { firstEntry: "", secondEntry: "", thirdEntry: "" },
  stepsTitle: "",
  stepsFirstArrow: "",
  stepsSecondArrow: "",
  doubleSectionBgTopColor: "",
  doubleSectionDescriptionTop: "",
  doubleSectionImageTop: "",
  doubleSectionTitleTop: "",
  doubleSectionTextColor: "",
  tagTitle: "",
  tagTitleColor: "",
  tagImg: "",
  tagTextButton: "",
  tagColorButton: "",
  tagColorTextButton: "",
  tagBgColor: ""
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case t.PRIMARY_TEXT_BUTTON:
      return { ...state, primaryTextButton: payload };
    case t.SECONDARY_TEXT_BUTTON:
      return { ...state, secondaryTextButton: payload };
    case t.HAS_COUPON:
      return { ...state, hasCoupon: payload };
    case t.COUPON_CARD_TITLE:
      return { ...state, couponCardTitle: payload };
    case t.COUPON_CARD_AUX_TEXT:
      return { ...state, couponCardAuxText: payload };
    case t.COUPON_CARD_BG_COLOR:
      return { ...state, couponCardBgColor: payload };
    case t.COUPON_CARD_PRIMARY_BUTTON_COLOR:
      return { ...state, couponCardPrimaryBtnColor: payload };
    case t.COUPON_CARD_PRIMARY_BUTTON_TEXT_COLOR:
      return { ...state, couponCardPrimaryBtnTextColor: payload };
    //LANDING OPTIONS
    case t.LANDING_ORDER:
      return { ...state, landingOrder: payload };
    case t.LANDING_TITLE:
      return { ...state, landingTitle: payload };
    case t.LANDING_NAME:
      return { ...state, landingName: payload };
    case t.IS_GENERIC:
      return { ...state, isGeneric: payload };
    case t.ESPECIFICS_COUPONS:
      return { ...state, especificsCoupons: payload };
    //NAV OPTIONS
    case t.PARTNER_LOGO:
      return { ...state, partnerLogo: payload };
    case t.VELOE_LOGO:
      return { ...state, veloeLogo: payload };
    //BANNER HEADER OPTIONS
    case t.BANNER_PRIMARY_TEXT:
      return { ...state, bannerPrimaryText: payload };
    case t.HAS_PRIMMARY_BTN:
      return { ...state, hasPrimmaryBtn: payload };
    case t.HAS_SECONDARY_BTN:
      return { ...state, hasSecondaryBtn: payload };
    case t.SECONDARY_BORDER_BTN:
      return { ...state, secondaryBorderBtn: payload };
    case t.BANNER_SECONDARY_TEXT:
      return { ...state, bannerSecondaryText: payload };
    case t.BANNER_BG_IMAGE:
      return { ...state, bannerBgImage: payload };
    case t.BANNER_TITULO:
      return { ...state, bannerTitle: payload };
    case t.BANNER_TITLE_COLOR:
      return { ...state, bannerTitleColor: payload };
    case t.BANNER_MESSAGE:
      return { ...state, bannerMessage: payload };
    case t.BANNER_MESSAGE_COLOR:
      return { ...state, bannerMessageColor: payload };
    case t.BANNER_BUTTON_PRIMARY_COLOR:
      return { ...state, bannerPrimaryBtnColor: payload };
    case t.BANNER_BUTTON_SECONDARY_COLOR:
      return {
        ...state,
        bannerPrimaryBtnTextColor: payload
      };
    case t.BANNER_BUTTON_PRIMARY_TEXT_COLOR:
      return { ...state, bannerSecondaryBtnColor: payload };
    case t.BANNER_BUTTON_SECONDARY_TEXT_COLOR:
      return {
        ...state,
        bannerSecondaryBtnTextColor: payload
      };
    //DEFAULT PROMO OPTIONS
    case t.PARKING:
      return { ...state, parking: payload };
    case t.TOLLS:
      return { ...state, tolls: payload };
    case t.PARKING_AND_TOLL:
      return { ...state, parkingAndToll: payload };
    case t.REGULAMENTO:
      return { ...state, regulamento: payload };
    //SIMPLE SECTION OPTIONS
    case t.SIMPLE_SECTION_BACKGROUND_COLOR:
      return { ...state, simpleSectionBgColor: payload };
    case t.SIMPLE_SECTION_DESCRIPTION:
      return {
        ...state,
        simpleSectionDescription: payload
      };
    case t.SIMPLE_SECTION_IMAGE:
      return { ...state, simpleSectionImage: payload };
    case t.SIMPLE_SECTION_TITLE:
      return { ...state, simpleSectionTitle: payload };
    case t.SIMPLE_SECTION_TEXT_COLOR: 
      return { ...state, simpleSectionTextColor: payload };
    //MAP OPTIONS
    case t.MAP_TITLE:
      return { ...state, mapTitle: payload };
    case t.MAP_DESCRIPTION:
      return { ...state, mapDescriptions: payload };
    //STEPS OPTIONS
    case t.STEPS_BG_COLOR:
      return { ...state, stepsBgColor: payload };
    case t.STEPS:
      return { ...state, steps: payload };
    case t.STEPS_TITLE:
      return { ...state, stepsTitle: payload };
    case t.STEPS_FIRST_ARROW:
      return { ...state, stepsFirstArrow: payload };
    case t.STEPS_SECOND_ARROW:
      return { ...state, stepsSecondArrow: payload };
  
    //DOUBLE SECTION OPTION
    case t.DOUBLE_SECTION_BG_TOP_COLOR:
      return {
        ...state,
        doubleSectionBgTopColor: payload
      };
    case t.DOUBLE_SECTION_DESCRIPTION_TOP:
      return {
        ...state,
        doubleSectionDescriptionTop: payload
      };
    case t.DOUBLE_SECTION_IMAGE_TOP:
      return {
        ...state,
        doubleSectionImageTop: payload
      };
    case t.DOUBLE_SECTION_TITLE_TOP:
      return { ...state, doubleSectionTitleTop: payload };
    case t.DOUBLE_SECTION_TEXT_COLOR:
      return { ...state, doubleSectionTextColor: payload };

    //TAG OPTION
    case t.TAG_TITLE:
      return {
        ...state,
        tagTitle: payload
      };
    case t.TAG_TITLE_COLOR:
      return {
        ...state,
        tagTitleColor: payload
      };
    case t.TAG_IMG:
      return {
        ...state,
        tagImg: payload
      };
    case t.TAG_TEXT_BUTTON:
      return {
        ...state,
        tagTextButton: payload
      };
    case t.TAG_COLOR_BUTTON:
      return {
        ...state,
        tagColorButton: payload
      };
    case t.TAG_COLOR_TEXT_BUTTON:
      return {
        ...state,
        tagColorTextButton: payload
      };
    case t.TAG_BG_COLOR:
      return {
        ...state,
        tagBgColor: payload
      };
    default:
      return state;
  }
}
